var RING=window.__ES_A["a-ec3c1bd202.png"];document.querySelectorAll("[data-ring]").forEach(function(i){i.src=RING});renderPdp();
(function(){
function bindSel(sel,kind){
  var list=kind==='ring'?SCENTS:SCENTS.filter(function(s){return s.g!=='seasonal'&&s.n!=='create it'});
  sel.innerHTML=list.map(function(s){return '<option>'+s.n+'</option>'}).join('');
  var item=sel.closest('.bb-item');if(!item)return;
  var img=item.querySelector('img');if(!img)return;
  var up=function(){var s=null;for(var i=0;i<SCENTS.length;i++){if(SCENTS[i].n===sel.value){s=SCENTS[i];break}}
    if(s){var slug=s.img.slice(3);var u=kind==='ring'?imSrc(s.img):(imSrc('ob-'+slug)||imSrc(s.img));if(u){img.src=u}}};
  sel.addEventListener('change',up);up();
}
document.querySelectorAll('select[aria-label="ring scent"]').forEach(function(x){bindSel(x,'ring')});
document.querySelectorAll('select[aria-label="oil scent"]').forEach(function(x){bindSel(x,'oil')});
document.querySelectorAll('[data-simg]').forEach(function(i){var u=imSrc(i.getAttribute('data-simg'));if(u)i.src=u});if(typeof fxReset==='function'){fxReset()}
if(typeof renderOilPdp==='function'){renderOilPdp()}
(function(){var sh=document.getElementById('opShelf');if(!sh)return;
SCENTS.forEach(function(s,i){
  if(s.g==='seasonal'||s.n==='create it')return;
  var b=document.createElement('button');
  b.className='chip2';
  b.innerHTML='<span class="d" style="background:'+(SCOL[s.n]||'#999')+'"></span>'+s.n;
  b.onclick=function(){oilPdp.scent=i;renderOilPdp();opToggle()};
  sh.appendChild(b);
});})();
(function(){var host=document.getElementById('scAll');if(!host)return;
var GROUPS=ARC.concat(['custom','seasonal']);
var GLABEL={custom:'make it yours',seasonal:'for a limited time'};
GROUPS.forEach(function(g){
  var items=[];SCENTS.forEach(function(s,i){if((s.moods||[s.mood]).indexOf(g)!==-1)items.push(i)});
  if(!items.length)return;
  var head=document.createElement('div');head.className='sc-mood-head';
  var isMood=!!MOODS[g];
  head.innerHTML='<span class="sc-mood-band" style="background:'+(isMood?'var(--'+g+')':'var(--sand)')+'"></span><h2>'+g+'</h2><span class="serif">'+(isMood?(MOODW[g]||''):(GLABEL[g]||''))+'</span>'
    +(isMood?'<a href="#" style="margin-left:auto;font-size:13px;font-weight:700;color:var(--lagoon-deep)" onclick="goHub(\''+g+'\');return false">the '+g+' shelf &rsaquo;</a>':'');
  host.appendChild(head);
  var grid=document.createElement('div');grid.className='sc-grid';
  items.forEach(function(i){
    var s=SCENTS[i];var col=SCOL[s.n]||'#999';var thumb=imSrc('scw-'+s.img.slice(3))||imSrc(s.img);
    var card=document.createElement('div');card.className='ing';
    card.setAttribute('data-n',s.n);card.setAttribute('data-moods',(s.moods||[s.mood]).join(','));
    card.innerHTML=(thumb?'<div class="ing-imgw" style="background:'+(SEDGE[s.img]||col)+'" onclick="openScentPdp('+i+')"><img loading="lazy" decoding="async" src="'+thumb+'" alt="'+s.n+'"></div>':'')
      +'<div class="ing-body"><b style="cursor:pointer" onclick="openScentPdp('+i+')">'+s.n+'</b>'
      +'<p>'+(s.a||'')+'</p>'
      +'<div class="ing-buy"><select aria-label="'+s.n+' option"><option data-p="'+esRingPrice(s.n,'5-pack')+'">ring 5-pack \u00b7 $'+esRingPrice(s.n,'5-pack').toFixed(2)+'</option><option data-p="'+esRingPrice(s.n,'single')+'">single ring \u00b7 $'+esRingPrice(s.n,'single').toFixed(2)+'</option>'
      +(s.g!=='seasonal'&&s.n!=='create it'?'<option data-p="'+esOilPrice(s.n)+'">oil 5 mL \u00b7 $'+esOilPrice(s.n).toFixed(2)+'</option>':'')
      +'</select><button class="quick-add" onclick="ingAdd(this,\''+s.n+'\')">add</button></div></div>';
    grid.appendChild(card);
  });
  host.appendChild(grid);
});
var ctrl=document.getElementById('scCtrl');
if(ctrl){
  var cur='';
  var inp=document.createElement('input');inp.type='search';inp.placeholder='search scents';inp.setAttribute('aria-label','search scents');
  inp.style.cssText='flex:1;min-width:170px;max-width:300px;padding:10px 16px;border:1px solid var(--line);border-radius:999px;background:var(--white);font:inherit;font-size:14px';
  ctrl.appendChild(inp);
  function apply(){
    var q=inp.value.trim().toLowerCase();
    document.querySelectorAll('#scAll .ing').forEach(function(cd){
      var ok=(!q||(cd.getAttribute('data-n')||'').indexOf(q)>-1)&&(!cur||((cd.getAttribute('data-moods')||'').split(',').indexOf(cur)>-1));
      cd.style.display=ok?'':'none';
    });
    document.querySelectorAll('#scAll .sc-mood-head').forEach(function(h){
      var g=h.nextElementSibling,any=false;
      if(g)g.querySelectorAll('.ing').forEach(function(cd){if(cd.style.display!=='none')any=true});
      h.style.display=any?'':'none';if(g)g.style.display=any?'':'none';
    });
  }
  var chips=[];
  ARC.forEach(function(mo){
    var b=document.createElement('button');b.className='chip2';b.textContent=mo;
    b.style.cssText='border-color:var(--'+mo+')';
    b.onclick=function(){cur=(cur===mo)?'':mo;chips.forEach(function(cb){cb.style.background=cb.textContent===cur?'var(--'+cb.textContent+')':'';cb.style.color=''});apply()};
    chips.push(b);ctrl.appendChild(b);
  });
  inp.addEventListener('input',apply);
}
})();
var fs=document.querySelector('.slide-finder');var fw=imSrc('hero-finder-wide');if(fs&&fw){fs.style.background='var(--cream) url("'+fw+'") no-repeat center right / cover'}var bs=document.querySelector('.slide-brand');var bw=imSrc('hero-brand-wide');if(bs&&bw){bs.style.background='var(--ink) url("'+bw+'") no-repeat center right / cover'}var hv=document.querySelector('.slide-video');if(hv){var hvKick=function(){hv.play().catch(function(){})};hvKick();document.addEventListener('visibilitychange',hvKick);window.addEventListener('pageshow',hvKick);setTimeout(hvKick,1200)}var ds=document.querySelector('.slide-duo');var dw=imSrc('hero-duo-wide');if(ds&&dw){ds.style.background='#0E6478 url("'+dw+'") no-repeat center right / cover'}var ps=document.querySelector('.slide-pumpkin');var pw=imSrc('hero-pumpkin-wide');if(ps&&pw){ps.style.background='#4a2410 url("'+pw+'") no-repeat center right / cover'}var cn=document.getElementById('clubNext');if(cn&&pw){cn.style.background='linear-gradient(90deg,rgba(74,36,16,.94) 30%,rgba(74,36,16,.55)),url("'+pw+'") no-repeat center right / cover'}})();
(function(){var q=new URLSearchParams(location.search);if(q.get('mega')){var mb=document.querySelector('[data-mega="'+q.get('mega')+'"]');if(mb){mb.click()}}var v=q.get('v');if(!v)return;
if(v==='hub'&&q.get('m')&&MOODS[q.get('m')]){goHub(q.get('m'))}
else if(v==='pdp'){var s=parseInt(q.get('s'),10);if(!isNaN(s)&&SCENTS[s]){pickScent(s)}go('pdp')}
else if(v==='oilpdp'){var so=parseInt(q.get('s'),10);openOilPdp(isNaN(so)?18:so)}
else if(v==='kitpdp'){var sk=parseInt(q.get('s'),10);openKitPdp(isNaN(sk)?0:sk)}
else if(v==='duopdp'){var sd=parseInt(q.get('s'),10);openDuoPdp(isNaN(sd)?0:sd)}
else if(document.getElementById('view-'+v)){go(v)}
if(q.get('y')){setTimeout(function(){scrollTo({top:parseInt(q.get('y'),10)||0,behavior:'instant'})},80)}})();
function prBuildOilGrid(){
  var grid=document.getElementById('prOilGrid');
  if(!grid) return;
  var q=document.getElementById('olSearch');
  if(q&&!q.__wired){q.__wired=1;q.addEventListener('input',function(){
    var v=q.value.trim().toLowerCase();
    grid.querySelectorAll('.pr-oil').forEach(function(cd){cd.style.display=(!v||(cd.getAttribute('data-n')||'').indexOf(v)>-1)?'':'none'});
  })}
  var SINGLES=['lemon','lemon-lime','orange','grapefruit','bergamot','lemongrass','coffee','peppermint','eucalyptus','frankincense','lavender'];
  function card(i){
    var s=SCENTS[i];
    var src=imSrc('ob-'+s.img.slice(3))||imSrc(s.img);
    var thumb=src?'<div class="pr-oil-stage" data-op="'+i+'" style="cursor:pointer"><img loading="lazy" decoding="async" src="'+src+'" alt="'+s.n+' oil bottle"></div>':'<div class="pr-oil-stage"></div>';
    return '<div class="pr-oil" data-n="'+s.n+'">'+thumb+
      '<div class="pr-oil-name" data-op="'+i+'" style="cursor:pointer"><span class="sdot" style="background:'+((typeof SCOL!=='undefined'&&SCOL[s.n])||'#999')+'"></span>'+s.n+'</div>'+
      '<div class="pr-oil-meta">5 mL \u00b7 $'+esOilPrice(s.n).toFixed(2)+'</div>'+
      '<button class="quick-add" data-oil="'+i+'">add</button></div>';
  }
  var singles='',blends='',i;
  for(i=0;i<SCENTS.length;i++){
    if(SCENTS[i].n==='create it'||SCENTS[i].g==='seasonal') continue;
    var one=card(i);
    if(SINGLES.indexOf(SCENTS[i].n)!==-1){singles+=one}else{blends+=one}
  }
  var head='style="grid-column:1/-1;margin:10px 0 0"';
  grid.innerHTML='<h2 id="oil-singles" '+head+'>single notes</h2>'+singles+
    '<h2 id="oil-blends" '+head+'>the blends</h2>'+blends+
    '<div id="oil-refills" style="grid-column:1/-1;background:var(--white);border:1px solid var(--line);border-radius:15px;padding:22px;display:flex;align-items:center;gap:18px;flex-wrap:wrap;margin-top:10px">'+
    '<div style="flex:1;min-width:240px"><h2 style="margin:0 0 6px">refill sets</h2><p class="serif" style="margin:0">stock the shelf: any five oils keep every ring in rotation. add five and the cart does the math.</p></div>'+
    '<button class="quick-add" style="flex:none" onclick="document.getElementById(\'oil-singles\').scrollIntoView({behavior:\'smooth\'})">pick your five</button></div>';
  grid.onclick=function(e){
    var t=e.target;
    if(t&&t.getAttribute&&t.getAttribute('data-oil')!==null){
      var idx=parseInt(t.getAttribute('data-oil'),10);
      quickAdd(SCENTS[idx].n+' oil 5 mL',esOilPrice(SCENTS[idx].n));
      return;
    }
    var op=t&&t.closest?t.closest('[data-op]'):null;
    if(op){openOilPdp(parseInt(op.getAttribute('data-op'),10))}
  };
}
function prWire(){
  var root=document.getElementById('view-products');
  if(!root) return;
  var goers=root.querySelectorAll('[data-go]');
  var i;
  for(i=0;i<goers.length;i++){
    (function(el){
      el.onclick=function(e){ if(e&&e.preventDefault)e.preventDefault(); go(el.getAttribute('data-go')); };
    })(goers[i]);
  }
  var adders=root.querySelectorAll('[data-add]');
  for(i=0;i<adders.length;i++){
    (function(el){
      el.onclick=function(){ esQuickAddSel(el); };
    })(adders[i]);
  }
  function on(id,fn){ var el=document.getElementById(id); if(el) el.onclick=function(e){ if(e&&e.preventDefault)e.preventDefault(); fn(); }; }
  on('prCtaMood',function(){ goHub('refresh'); });
  on('prCtaFinder',function(){ go('finder'); });
}
prBuildOilGrid();
prWire();
/* bundles view is static. quick adds and the builder link call the shared
   globals quickAdd() and go() straight from inline handlers, and images
   are filled by the shared data-simg loader. no extra wiring needed. */
var srIndex = [];
var srPopular = [];
function srBoot(){
  var i, moods, pages, popNames, j;
  for (i = 0; i < SCENTS.length; i++) {
    (function(idx){
      var s = SCENTS[idx];
      srIndex.push({ g: 'scent rings', t: s.n + " scent ring", s: s.a, run: function(){ openScentPdp(idx); } });
      if (s.g !== 'seasonal' && s.n !== 'create it') {
        srIndex.push({ g: 'oils', t: s.n + " oil, 5 mL", s: 'the refill. 30+ ring soaks per bottle.', run: function(){ if(typeof oilPdp!=='undefined'){oilPdp.scent=idx;if(typeof renderOilPdp==='function')renderOilPdp()} go('oilpdp'); } });
      }
    })(i);
  }
  moods = [["refresh","start again"],["focus","one thing at a time"],["breathe","clear runway"],["relief","back to baseline"],["relax","the day, done"],["sleep","lights out, actually"]];
  for (i = 0; i < moods.length; i++) {
    (function(m){
      srIndex.push({ g: 'moods', t: "the " + m[0] + " shelf", s: m[1], run: function(){ goHub(m[0]); } });
    })(moods[i]);
  }
  pages = [
    ["every scent", "all 23 rings, one page", function(){ go('scents'); }],
    ["the scent finder quiz", "eight quick questions, meet your ring", function(){ go('finder'); }],
    ["bundles and refresh kits", "curated sets, better together", function(){ go('bundles'); }],
    ["essence of the month", "the club. a new box, every month", function(){ go('club'); }],
    ["shop by product", "rings, oils, and refills", function(){ go('products'); }],
    ["the oils, 5 mL", "every scent\u2019s refill, $14.99", function(){ go('oils'); }],
    ["subscribe", "your mood, refilled monthly", function(){ go('subscribe'); }],
    ["learn how it works", "the science, minus the jargon", function(){ go('learn'); }],
    ["faq", "quick answers", function(){ goLearn('lrn-faq'); }],
    ["the journal", "notes on scent and mood", function(){ goLearn('lrn-journal'); }],
    ["pumpkin spice drop", "the seasonal one, live now", function(){ go('campaign'); }],
    ["the essence club", "the founding box: 5-pack, oil, bonus, wildcard", function(){ go('club'); }],
    ["the refresh kit", "2 rings + oil + soaking bay", function(){ openKitPdp(0); }],
    ["the scent & soak duo", "oil + topper + 2 rings, the whole loop", function(){ openDuoPdp(); }],
    ["soaking bays", "the overnight spa for tired rings", function(){ openCollection('bays'); }],
    ["travel cases", "for noses that leave the house", function(){ openCollection('travel'); }],
    ["tabletop diffusers", "whole-room scent, glass dome", function(){ openCollection('diffusers'); }],
    ["body care", "lotions in the house scents", function(){ openCollection('lotion'); }],
    ["our story", "two smelly flights and a shark tank", function(){ go('about'); }]
  ];
  for (i = 0; i < pages.length; i++) {
    (function(p){
      srIndex.push({ g: 'pages', t: p[0], s: p[1], run: p[2] });
    })(pages[i]);
  }
  popNames = ["lavender scent ring", "peppermint scent ring", "the scent finder quiz", "bundles and refresh kits", "faq"];
  for (i = 0; i < popNames.length; i++) {
    for (j = 0; j < srIndex.length; j++) {
      if (srIndex[j].t === popNames[i]) { srPopular.push(srIndex[j]); break; }
    }
  }
}
/* Oct 16 (Jacob, meeting #34): search finds problems ("migraine", "fitness", "nurse"), every live bundle and kit,
   synonyms, plurals and small typos ("lavendar"). Keywords live in e.k and are searched but never shown. */
var SR_SYN = {anxious:'anxiety',anxiousness:'anxiety',panic:'anxiety',worried:'anxiety',queasy:'nausea',nauseous:'nausea',sick:'nausea',carsick:'nausea',seasick:'nausea',vomit:'nausea',pregnant:'pregnancy',preggo:'pregnancy',insomnia:'sleep',sleepy:'sleep',tired:'energy',exhausted:'energy',sleepless:'sleep',workout:'fitness',gym:'fitness',exercise:'fitness',running:'fitness',run:'fitness',training:'fitness',hyrox:'fitness',sports:'fitness',nurses:'nurse',nursing:'nurse',rn:'nurse',doctor:'healthcare',hospital:'healthcare',medical:'healthcare',headaches:'headache',migraines:'migraine',sinuses:'sinus',congested:'congestion',stuffy:'congestion',allergy:'allergies',hayfever:'allergies',pollen:'allergies',cold:'congestion',flu:'immunity',refil:'refill',refills:'refill',reinfuse:'refill',recharge:'refill',sampler:'sample',samples:'sample',variety:'sample',study:'focus',studying:'focus',concentrate:'focus',concentration:'focus',calming:'calm',relaxing:'relax',smell:'scent',smells:'scent',odor:'scent',unscented:'blank',diy:'blank',gift:'gifts',present:'gifts',car:'drive'};
var SR_KW = {
  'peppermint':'headache migraine nausea focus energy cooling motion fitness',
  'eucalyptus':'congestion sinus breathe breathing allergies shower steam fitness',
  'breathe easy blend':'congestion sinus breathe breathing allergies immunity fitness',
  'allergy relief':'allergies sinus congestion sneezing breathe',
  'immunity blend':'immunity congestion winter germs travel flight',
  'nausea relief blend':'nausea motion drive travel flight pregnancy morning stomach',
  'stress relief blend':'stress anxiety calm relax overwhelm work',
  'lavender':'sleep calm relax anxiety stress bedtime',
  'lavender mint':'calm relax stress headache',
  'rest easy blend':'sleep bedtime night calm',
  'frankincense':'calm meditation grounding yoga',
  'energy blend':'energy focus fitness afternoon',
  'coffee':'energy morning wake caffeine',
  'rosemary mint':'focus clarity memory energy',
  'lemon':'citrus energy mood uplifting','lemon-lime':'citrus energy mood uplifting','orange':'citrus energy mood uplifting',
  'grapefruit':'citrus energy mood uplifting fitness','bergamot':'citrus calm mood uplifting','lemongrass':'citrus energy uplifting',
  'create it':'blank custom','pumpkin spice':'fall autumn seasonal holiday'
};
var SR_MOOD = {refresh:'energy citrus morning uplifting refill', focus:'focus work energy', breathe:'congestion allergies sinus breathing immunity', relief:'headache migraine nausea', relax:'stress anxiety calm', sleep:'sleep bedtime night calm'};
var SR_PAGE = {
  'the refresh kit':'refill kit soaking starter', 'bundles and refresh kits':'bundles kits refill sets gifts', 'soaking bays':'refill soak',
  'the scent finder quiz':'quiz help choose recommend finder', 'faq':'help questions shipping returns how', 'essence of the month':'subscription monthly box membership club',
  'the essence club':'subscription monthly box membership', 'subscribe':'subscription monthly refill', 'our story':'shark tank founder about',
  'tabletop diffusers':'home room diffuser', 'body care':'lotion', 'travel cases':'travel flight case', 'the oils, 5 mL':'oils refill',
  'every scent':'all scents rings sample'
};
function srNorm(t){ return (t||'').toLowerCase().replace(/&/g,' and ').replace(/[^a-z0-9\- ]+/g,' ').replace(/\s+/g,' ').trim(); }
function srStem(w){ if (w.length > 4 && /ies$/.test(w)) return w.slice(0,-3)+'y'; if (w.length > 4 && /es$/.test(w) && !/ses$/.test(w)) return w.slice(0,-2); if (w.length > 3 && /s$/.test(w) && !/ss$/.test(w)) return w.slice(0,-1); return w; }
function srWords(q){ var out = [], ws = srNorm(q).split(' '); for (var i = 0; i < ws.length; i++) { var w = ws[i]; if (!w || /^(a|an|the|for|and|of|to|my|with|i|me|in|on|ring|rings)$/.test(w) && ws.length > 1) continue; if (w) out.push(w); } return out; }
function srLev(a,b){ if (Math.abs(a.length-b.length) > 2) return 9; var m = a.length, n = b.length, d = [], i, j; for (i = 0; i <= m; i++) d[i] = [i]; for (j = 0; j <= n; j++) d[0][j] = j; for (i = 1; i <= m; i++) for (j = 1; j <= n; j++) d[i][j] = Math.min(d[i-1][j]+1, d[i][j-1]+1, d[i-1][j-1]+(a[i-1]===b[j-1]?0:1)); return d[m][n]; }
function srWordScore(w, title, tToks, sub, kToks){
  var alts = [w, srStem(w)]; if (SR_SYN[w]) alts.push(SR_SYN[w]); if (SR_SYN[srStem(w)]) alts.push(SR_SYN[srStem(w)]);
  var best = 0, a, i, k, t;
  for (i = 0; i < alts.length; i++) {
    a = alts[i]; if (!a) continue;
    if (title.indexOf(a) === 0) best = Math.max(best, 6);
    else if ((' '+title).indexOf(' '+a) !== -1) best = Math.max(best, 5);
    else if (title.indexOf(a) !== -1) best = Math.max(best, 4);
    if (best < 3 && (' '+kToks.join(' ')+' ').indexOf(' '+a) !== -1) best = Math.max(best, 3);
    if (best < 2 && sub.indexOf(a) !== -1 && a.length > 2) best = Math.max(best, 2);
  }
  if (best === 0 && w.length >= 4) {
    var lim = w.length >= 7 ? 2 : 1, all = tToks.concat(kToks);
    for (k = 0; k < all.length; k++) { t = all[k]; if (t.length < 3) continue; if (srLev(w, t) <= lim || (t.length > w.length && srLev(w, t.slice(0, w.length)) <= 1 && w.length >= 5)) { best = (k < tToks.length) ? 1.5 : 1; break; } }
  }
  return best;
}
function srScore(e, words){
  if (!e._n) { e._n = srNorm(e.t); e._tt = e._n.split(' '); e._s = srNorm(e.s); e._k = srNorm(e.k || '').split(' ').filter(Boolean).map(srStem).concat(srNorm(e.k || '').split(' ').filter(Boolean)); }
  var total = 0;
  for (var i = 0; i < words.length; i++) { var sc = srWordScore(words[i], e._n, e._tt, e._s, e._k); if (!sc) return 0; total += sc; }
  return total + (e.g === 'bundles' ? 0.2 : 0);
}
function srBoost(){
  var i, e, m;
  for (i = 0; i < srIndex.length; i++) {
    e = srIndex[i];
    if (e.g === 'scent rings' || e.g === 'oils') { m = e.t.replace(/ scent ring$| oil, 5 mL$/, ''); e.k = (SR_KW[m] || '') + (e.g === 'oils' ? ' refill oil essential drops' : ''); }
    else if (e.g === 'moods') { m = e.t.replace(/^the | shelf$/g, ''); e.k = SR_MOOD[m] || ''; }
    else if (SR_PAGE[e.t]) e.k = SR_PAGE[e.t];
  }
  function to(h){ return function(){ location.href = '/products/' + h; }; }
  var B = [
    ['the try-all sampler', 'all 20 scents, one of each', 'sample every scent variety gifts', function(){ openGearPdp('tryall'); }],
    ['starter kit 5-pack', 'five best sellers to start with', 'starter beginner first best sellers', to('starter-kit-5-pack-bundle')],
    ['calming blends 5-pack', 'five rings for calm', 'calm stress anxiety relax sleep', to('calming-blends-5-pack-bundle')],
    ['respiratory 5-pack', 'five rings for clear breathing', 'breathe congestion allergies sinus immunity', to('respiratory-blends-bundle-pack')],
    ['citrus 5-pack', 'five bright citrus rings', 'citrus energy uplifting mood', to('citrus-5-pack-bundle')],
    ['self care 5-pack', 'five rings for a better day', 'self care calm relax gifts', to('self-care-bundle')],
    ['healthcare bundle: for the ones who stay', 'for nurses and long shifts', 'nurse healthcare shift hospital gifts', to('healthcare-bundle-for-the-ones-who-stay')],
    ['healthcare workers 5-pack', 'five rings for the shift', 'nurse healthcare shift hospital', to('healthcare-workers-bundle-5-ring')],
    ['mommy and nausea 5-pack', 'five rings for queasy days', 'nausea pregnancy morning mom motion', to('mommy-nausea-5-pack-bundle')],
    ['migraine 5-pack', 'five rings for head and sinus days', 'migraine headache sinus head relief', to('migraine-bundle-5-ring-head-sinus-support-collection')],
    ['fitness 5-pack', 'five rings for workouts', 'fitness energy breathe active', to('fitness-bundle')],
    ['focus 5-pack', 'five rings for concentration', 'focus work energy clarity', to('focus-bundle')],
    ['sleep 5-pack', 'five rings to wind down', 'sleep bedtime calm night', to('sleep-bundle')],
    ['create it 5-pack', 'five unscented rings', 'blank custom', to('create-it-5-pack-bundle')],
    ['custom blends 5-pack', 'five of the house blends', 'blends variety', to('custom-blends-5-pack-bundle')],
    ['pick your mix 5-pack', 'choose any five scents', 'custom choose mix variety', to('pick-your-mix-5-pack')],
    ['essential oil 5-pack', 'five 5 mL oils', 'oils refill variety', to('essential-oil-5-pack-bundle')],
    ['5-pack and oil bundle', 'five rings plus the matching oil', 'refill oil kit', to('5-pack-oil-bundle')],
    ['essence mystery box', 'a surprise box of favorites', 'surprise gifts', to('essence-mystery-box')],
    ['travel amenity kit', 'everything for a trip', 'travel flight trip gifts', to('travel-amenity-kit')],
    ['pearl travel case, soaking bay, oil and rings', 'the travel set', 'travel case refill gifts', to('pearl-shell-case-soaking-bay-oil')],
    ['travel oil and ring carrying case', 'five oil slots and a ring pocket', 'travel case', to('travel-oil-ring-carrying-case')],
    ['glass reinfusion bay', 'soak rings back to full scent', 'refill soak glass bay', to('glass-soaking-bay-and-ring')],
    ['portable diffuser', 'scent for the car and desk', 'drive diffuser travel', to('aromatherapy-car-diffuser')],
    ['fractionated coconut oil, 2 fl oz', 'organic carrier oil', 'carrier dilute coconut', to('coconut-oil-2-fl-oz-organic-fractionated')]
  ];
  for (i = 0; i < B.length; i++) srIndex.push({ g: 'bundles', t: B[i][0], s: B[i][1], k: B[i][2] + ' bundle set pack', run: B[i][3] });
  if (typeof KITSP !== 'undefined') {
    var KM = ['citrus energy morning refresh', 'focus work energy', 'headache relief rough', 'nurse shift energy healthcare', 'calm relax stress evening', 'sleep bedtime night'];
    for (i = 0; i < KITSP.length; i++) (function(idx){ srIndex.push({ g: 'refresh kits', t: KITSP[idx].n, s: 'refresh kit · 2 rings + oil + soaking bay', k: 'kit refill ' + (KM[idx] || ''), run: function(){ openKitPdp(idx); } }); })(i);
  }
}
function srRow(entry){
  var b = document.createElement('button');
  b.className = 'sr-row';
  b.type = 'button';
  b.innerHTML = '<div class="sr-row-title"></div><div class="sr-row-sub"></div>';
  b.firstChild.textContent = entry.t;
  b.lastChild.textContent = entry.s;
  b.onclick = function(){ closeSearch(); entry.run(); };
  return b;
}
var srVisible = [], srSel = 0;
function srPaintSel(){
  var rows = document.querySelectorAll('#srResults .sr-row');
  for (var i = 0; i < rows.length; i++) {
    if (i === srSel) { rows[i].setAttribute('aria-current','true'); rows[i].scrollIntoView({block:'nearest'}); }
    else rows[i].removeAttribute('aria-current');
  }
}
function srRender(q){
  var box = document.getElementById('srResults');
  var i, e, lab, groups, gi, g;
  box.innerHTML = '';
  srVisible = []; srSel = 0;
  q = (q || '').toLowerCase().replace(/^\s+|\s+$/g, '');
  if (!q) {
    lab = document.createElement('div');
    lab.className = 'sr-label';
    lab.textContent = 'popular';
    box.appendChild(lab);
    for (i = 0; i < srPopular.length; i++) { srVisible.push(srPopular[i]); box.appendChild(srRow(srPopular[i])); }
    srPaintSel();
    return;
  }
  var words = srWords(q);
  var scored = [];
  for (i = 0; i < srIndex.length; i++) {
    e = srIndex[i];
    var sc = srScore(e, words);
    if (sc > 0) scored.push([sc, e, i]);
  }
  scored.sort(function(a,b){ return (b[0] - a[0]) || (a[2] - b[2]); });
  var hits = [];
  for (i = 0; i < scored.length && hits.length < 12; i++) hits.push(scored[i][1]);
  if (!hits.length) {
    lab = document.createElement('div');
    lab.className = 'sr-none';
    lab.textContent = 'nothing yet. try a scent, a mood, or "quiz".';
    box.appendChild(lab);
    return;
  }
  groups = [];
  for (i = 0; i < hits.length; i++) {
    g = hits[i].g || 'pages';
    if (groups.indexOf(g) === -1) groups.push(g);
  }
  for (gi = 0; gi < groups.length; gi++) {
    lab = document.createElement('div');
    lab.className = 'sr-label';
    lab.textContent = groups[gi];
    box.appendChild(lab);
    for (i = 0; i < hits.length; i++) {
      if ((hits[i].g || 'pages') === groups[gi]) { srVisible.push(hits[i]); box.appendChild(srRow(hits[i])); }
    }
  }
  srPaintSel();
}
function srOnKeydown(e){
  if (e.key === 'Escape' || e.keyCode === 27) { closeSearch(); return; }
  if (e.key === 'ArrowDown' || e.keyCode === 40) { e.preventDefault(); if (srSel < srVisible.length - 1) srSel++; srPaintSel(); return; }
  if (e.key === 'ArrowUp' || e.keyCode === 38) { e.preventDefault(); if (srSel > 0) srSel--; srPaintSel(); return; }
  if (e.key === 'Enter' || e.keyCode === 13) { e.preventDefault(); if (srVisible[srSel]) { closeSearch(); srVisible[srSel].run(); } return; }
}
window.openSearch = function(){
  if (!srIndex.length) { srBoot(); srBoost(); }
  var ov = document.getElementById('searchOverlay');
  var inp = document.getElementById('srInput');
  ov.hidden = false;
  inp.value = '';
  srRender('');
  inp.focus();
  document.addEventListener('keydown', srOnKeydown);
};
window.closeSearch = function(){
  document.getElementById('searchOverlay').hidden = true;
  document.removeEventListener('keydown', srOnKeydown);
};
document.getElementById('srInput').addEventListener('input', function(){ srRender(this.value); });
document.getElementById('srInput').addEventListener('keydown', srOnKeydown);
(function(){
  var plans = document.getElementById('sbPlans');
  var cta = document.getElementById('sbCta');
  if (!plans || !cta) return;
  var cards = plans.getElementsByClassName('sb-plan');
  function labelFor(card){
    return card.getAttribute('data-plan') === 'essence of the month'
      ? 'start essence of the month · $19.99/mo'
      : 'start your pick · $18.69/mo';
  }
  function select(card){
    for (var i = 0; i < cards.length; i++) cards[i].removeAttribute('aria-current');
    card.setAttribute('aria-current', 'true');
    cta.textContent = labelFor(card);
  }
  for (var i = 0; i < cards.length; i++) {
    (function(card){
      card.onclick = function(){ select(card); if(card.getAttribute('data-plan')==='essence of the month'){go('club');setTimeout(function(){var b=document.querySelector('.club-month-band');if(b)b.scrollIntoView({behavior:'smooth'})},120);} };
      card.onkeydown = function(e){
        if (e.key === 'Enter' || e.key === ' ' || e.keyCode === 13 || e.keyCode === 32) { e.preventDefault(); select(card); }
      };
    })(cards[i]);
  }
  cta.onclick = function(){
    var sel = plans.querySelector('.sb-plan[aria-current="true"]') || cards[0];
    quickAdd(sel.getAttribute('data-plan') + ' subscription', parseFloat(sel.getAttribute('data-price')));
  };
})();

  /* fluid hero: apple-design sections 2, 3, 5, 6 */
  (function(){
    var sl=document.getElementById('heroSlider'); if(!sl) return;
    var drag=null, springRaf=null, springState=null, clickSquash=false;
    function els(){return sl.querySelectorAll('.slide')}
    function setX(el,x){el.style.transform='translateX('+x+'px)'}
    function clearInline(el){if(!el)return;el.style.transform='';el.style.display='';el.style.position='';el.style.inset='';el.style.zIndex=''}
    function project(v){var d=0.998;return (v/1000)*d/(1-d)}
    sl.addEventListener('pointerdown',function(e){
      if(e.pointerType==='mouse'&&e.button!==0)return;
      if(springRaf){ /* grab mid-flight: adopt the live value */
        cancelAnimationFrame(springRaf);springRaf=null;
        var s=springState;springState=null;
        drag={x0:e.clientX-s.x,y0:e.clientY,committed:true,hist:[],cur:s.cur,inc:s.inc,incIdx:s.incIdx,dir:s.dir,w:s.w,id:e.pointerId};
        try{sl.setPointerCapture(e.pointerId)}catch(err){}
        clickSquash=true;clearInterval(slideTimer);
        return;
      }
      drag={x0:e.clientX,y0:e.clientY,committed:false,hist:[],cur:null,inc:null,incIdx:-1,dir:0,w:sl.offsetWidth,id:e.pointerId};
    });
    sl.addEventListener('pointermove',function(e){
      if(!drag)return;
      var dx=e.clientX-drag.x0, dy=e.clientY-drag.y0;
      if(!drag.committed){
        if(Math.abs(dx)>10&&Math.abs(dx)>Math.abs(dy)){
          drag.committed=true;clickSquash=true;
          try{sl.setPointerCapture(drag.id)}catch(err){}
          clearInterval(slideTimer);
          drag.cur=els()[slideIdx];
          drag.cur.style.position='relative';drag.cur.style.zIndex='2';
        } else if(Math.abs(dy)>14){drag=null;return}
        else return;
      }
      var dir=dx<0?1:-1;
      if(dir!==drag.dir){
        clearInline(drag.inc);
        var all=els();
        drag.incIdx=(slideIdx+dir+all.length)%all.length;
        drag.inc=all[drag.incIdx];drag.dir=dir;
        drag.inc.style.display='block';drag.inc.style.position='absolute';drag.inc.style.inset='0';drag.inc.style.zIndex='1';
      }
      setX(drag.cur,dx);
      setX(drag.inc,drag.dir*drag.w+dx);
      drag.hist.push({x:e.clientX,t:e.timeStamp});
      if(drag.hist.length>6)drag.hist.shift();
    });
    function velocity(){
      var hh=drag.hist;if(hh.length<2)return 0;
      var a=hh[0],b=hh[hh.length-1],dt=(b.t-a.t)/1000;
      return dt>0?(b.x-a.x)/dt:0;
    }
    function finish(e){
      if(!drag)return;
      if(!drag.committed){drag=null;return}
      var dx=e.clientX-drag.x0, v=velocity();
      var commit;
      if(Math.abs(v)>400){commit=(v<0)===(drag.dir===1)}         /* velocity sign decides */
      else{var proj=dx+project(v);commit=Math.abs(proj)>drag.w/2} /* else momentum projection */
      var target=commit?-drag.dir*drag.w:0;
      var d=drag;drag=null;
      if(reduceMotion){settleNow(d,commit);return}
      var x=dx,vel=v,last=performance.now();
      springState={x:x,cur:d.cur,inc:d.inc,incIdx:d.incIdx,dir:d.dir,w:d.w};
      var watchdog=setTimeout(function(){if(springRaf){cancelAnimationFrame(springRaf);settleNow(d,commit)}},900);
      function step(now){
        var dt=Math.min((now-last)/1000,0.032);last=now;
        var F=-170*(x-target)-26*vel;
        vel+=F*dt;x+=vel*dt;
        springState.x=x;
        setX(d.cur,x);setX(d.inc,d.dir*d.w+x);
        if(Math.abs(x-target)<0.5&&Math.abs(vel)<20){clearTimeout(watchdog);settleNow(d,commit)}
        else{springRaf=requestAnimationFrame(step)}
      }
      springRaf=requestAnimationFrame(step);
    }
    function settleNow(d,commit){
      springRaf=null;springState=null;
      clearInline(d.cur);clearInline(d.inc);
      slideTo(commit?d.incIdx:slideIdx);
    }
    sl.addEventListener('pointerup',finish);
    sl.addEventListener('pointercancel',function(e){if(drag&&drag.committed){finish(e)}else{drag=null}});
    sl.addEventListener('click',function(e){if(clickSquash){e.stopPropagation();e.preventDefault();clickSquash=false}},true);
  })();
